import styles from './index.module.scss';

const PartnerBtnCN = () => {
    const hendleClick = () => {
        window.open('https://ecoflow.feishu.cn/share/base/form/shrcnHslMKYvbJeBzG8Qx0WaOlb?from=navigation');
    };
    return (
        <div className={styles.partnerBtnCN} onClick={hendleClick}>
            加入正浩EcoFlow合作伙伴计划
        </div>
    );
};

export default PartnerBtnCN;
